import React from 'react';
import logoDark from '../assets/logo-dark.png';
import logoLight from '../assets/logo-light.png';

/**
 * Логотип TeSalut. Два варианта: жёлтый знак на чёрном для тёмной темы и
 * чёрный на жёлтом для светлой — переключаются через CSS, без мигания.
 */
const BrandLogo = ({ className = '', size }) => {
  const style = size ? { width: size, height: size } : undefined;

  return (
    <span className={`brand-logo ${className}`.trim()} style={style}>
      <img className="brand-logo-img brand-logo-img--light" src={logoLight} alt="TeSalut!" />
      <img className="brand-logo-img brand-logo-img--dark" src={logoDark} alt="" aria-hidden="true" />
    </span>
  );
};

export default BrandLogo;
